export default {
  methods: {
    mapLayerSnowmakingHydrantsAdd() {
      this.initPollSnowmakingHydrants();
      this.map.addSource("hydrants", {
        type: "geojson",
        data: this.computedSnowmakingHydrantsGeoJson
      });

      this.map.addLayer({
        filter: ["==", "c_colour", "Grey"],
        id: "hydrants-grey",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Grey",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Black
      this.map.addLayer({
        filter: ["==", "c_colour", "Black"],
        id: "hydrants-black",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Black",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS White
      this.map.addLayer({
        filter: ["==", "c_colour", "White"],
        id: "hydrants-white",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "White",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Purple
      this.map.addLayer({
        filter: ["==", "c_colour", "Purple"],
        id: "hydrants-purple",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Purple",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Blue
      this.map.addLayer({
        filter: ["==", "c_colour", "Blue"],
        id: "hydrants-blue",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Blue",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Red
      this.map.addLayer({
        filter: ["==", "c_colour", "Red"],
        id: "hydrants-red",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Red",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Green
      this.map.addLayer({
        filter: ["==", "c_colour", "Green"],
        id: "hydrants-green",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Green",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS None
      this.map.addLayer({
        filter: ["==", "c_colour", "None"],
        id: "hydrants-none",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "White",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Yellow
      this.map.addLayer({
        filter: ["==", "c_colour", "Yellow"],
        id: "hydrants-yellow",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Yellow",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Cyan
      this.map.addLayer({
        filter: ["==", "c_colour", "Cyan"],
        id: "hydrants-49c6bc",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "#49c6bc",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Orange
      this.map.addLayer({
        filter: ["==", "c_colour", "Orange"],
        id: "hydrants-orange",
        type: "circle",
        source: "hydrants",
        paint: {
          "circle-radius": 4,
          "circle-color": "Orange",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // Default
      this.map.addLayer({
        id: "hydrants-label-default",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "Black",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // 30A ONLY
      this.map.addLayer({
        filter: ["all", ["==", "30a", "1"], ["==", "60a", "0"]],
        id: "hydrants-label-30-only",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "White",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // DOUBLE 30 ONLY
      this.map.addLayer({
        filter: ["all", ["==", "30a", "2"], ["==", "60a", "0"]],
        id: "hydrants-label-dbl-30-only",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "#ff7f00",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], 3],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // 30-60
      this.map.addLayer({
        filter: ["all", ["==", "30a", "1"], ["==", "60a", "1"]],
        id: "hydrants-label-30-60",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "#33a02c",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // No Power
      this.map.addLayer({
        filter: ["all", ["==", "30a", "0"], ["==", "60a", "0"]],
        id: "hydrants-label-no-pwr",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "#c95af1",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // 60 only
      this.map.addLayer({
        filter: ["all", ["==", "30a", "0"], ["==", "60a", "1"]],
        id: "hydrants-label-60-only",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "#8cf478",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // dbl-60 only
      this.map.addLayer({
        filter: ["all", ["==", "30a", "0"], ["==", "60a", "2"]],
        id: "hydrants-label-dbl-60-only",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": "Grey",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // TOWERS TYPE 1
      this.map.addLayer({
        filter: ["==", "tower_type", "1"],
        id: "hydrants-label-twr-1",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"],
          visibility: "visible"
        },
        paint: {
          "text-color": "Red",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });

      // TOWERS TYPE 2
      this.map.addLayer({
        filter: ["==", "tower_type", "2"],
        id: "hydrants-label-twr-2",
        type: "symbol",
        source: "hydrants",
        layout: {
          "text-field": "{hydrnt_num}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [0.4, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"],
          visibility: "visible"
        },
        paint: {
          "text-color": "#2389cd",
          "text-halo-color": [
            "case",
            ["==", ["get", "tower_type"], "3"],
            "#2389cd",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "60a"], "0"]],
            "#9714a0",
            ["all", ["!=", ["get", "air"], "0"], ["!=", ["get", "30a"], "0"]],
            "#9714a0",
            "Lightgrey"
          ],
          "text-halo-width": 2
        }
      });
    },
    // method to remove all layers and the source
    mapLayerSnowmakingHydrantsRemove() {
      this.cancelPollSnowmakingHydrants();
      this.map.removeLayer("hydrants-grey");
      this.map.removeLayer("hydrants-black");
      this.map.removeLayer("hydrants-white");
      this.map.removeLayer("hydrants-purple");
      this.map.removeLayer("hydrants-blue");
      this.map.removeLayer("hydrants-red");
      this.map.removeLayer("hydrants-green");
      this.map.removeLayer("hydrants-none");
      this.map.removeLayer("hydrants-yellow");
      this.map.removeLayer("hydrants-orange");
      this.map.removeLayer("hydrants-49c6bc");
      this.map.removeLayer("hydrants-label-twr-2");
      this.map.removeLayer("hydrants-label-twr-1");
      this.map.removeLayer("hydrants-label-30-only");
      this.map.removeLayer("hydrants-label-dbl-30-only");
      this.map.removeLayer("hydrants-label-30-60");
      this.map.removeLayer("hydrants-label-no-pwr");
      this.map.removeLayer("hydrants-label-60-only");
      this.map.removeLayer("hydrants-label-dbl-60-only");
      this.map.removeLayer("hydrants-label-default");

      this.map.removeSource("hydrants");
    },
    // method to create the geojson polling
    initPollSnowmakingHydrants() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
        dept: "snowmaking",
        layer: "hydrants",
        token: this.computedAuthToken
      });
      this.pollSnowmakingHydrantsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
          dept: "snowmaking",
          layer: "hydrants",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    // method to cancel poll
    cancelPollSnowmakingHydrants() {
      this.pollSnowmakingHydrantsInterval = clearInterval(
        this.pollSnowmakingHydrantsInterval
      );
    }
  },
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    // the geojson
    computedSnowmakingHydrantsGeoJson() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson;
    },
    // visibility
    computedSnowmakingHydrantsMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.visibility
        .mapView;
    },
    // grabs the interval from the vuex state
    computedInterval() {
      return this.$store.state.general.interval;
    },
    computedSingleView() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.visibility
        .singleView;
    }
  },
  watch: {
    // watches the vuex state and if geojson changes removes then re-adds layers/source
    "$store.state.mapLayers.snowmaking.layers.hydrants.geojson": {
      handler() {
        if (this.computedSnowmakingHydrantsMapVisibility) {
          this.mapLayerSnowmakingHydrantsRemove();
          this.mapLayerSnowmakingHydrantsAdd();
        }
      }
    },
    // watches the vuex state of visibility and adds or removes the layer/source
    "$store.state.mapLayers.snowmaking.layers.hydrants.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingHydrantsAdd();
      } else {
        this.mapLayerSnowmakingHydrantsRemove();
      }
    }
  },
  beforeDestroy() {
    // cancels poll on component destroy
    this.cancelPollSnowmakingHydrants();
  }
};
